import moment from 'moment';
import accounting from 'accounting';
import _ from 'underscore';

function CustomerProfileCtrl($scope, $state, $stateParams, $q, $sce, venueService, organizationService, sdkUtils, alertService, admissionGroupService, dateUtilsService, customerService, userService, loggerService, ERROR_MESSAGES) { // eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();

  _initScope();

  $q.all([
      _getCustomer(),
      _getVenues(),
      _getAdmissionGroups()
    ])
    .then(() => {
      $scope.loading = false;

      _processAdmissionGroups();
    });

  function _initScope() {
    $scope.loading = true;
    $scope.visits = 0;

    $scope.getMinText = function (minimum) {
      minimum = minimum || 0;

      if (parseFloat(minimum) > 50) {
        minimum = `$${minimum} Minimum`;
      }

      if (parseFloat(minimum) <= 50) {
        minimum = `${minimum} Bottle Minimum.`;
      }

      if (parseFloat(minimum) === 0) {
        minimum = 'No Minimum. ';
      }

      return minimum;
    };

    $scope.getFirstVisit = function () {
      return $scope.customer && $scope.customer.stats && $scope.customer.stats.firstVisit ? moment($scope.customer.stats.firstVisit).format(' MMM DD, YYYY') : 'N/A';
    };

    $scope.getLastVisit = function () {
      return $scope.customer && $scope.customer.stats && $scope.customer.stats.latestVisit ? moment($scope.customer.stats.latestVisit).format(' MMM DD, YYYY') : 'N/A';
    };

    $scope.getTotalSpent = function () {
      return $scope.customer && $scope.customer.stats ? accounting.formatMoney(($scope.customer.stats.totalSpend || 0).toFixed(2)) : 'N/A';
    };

    $scope.getSpend = function (spend) {
      if (!spend) return '';

      spend = spend || 0;

      if (parseFloat(spend) > 0) {
        spend = `$${spend}`;
      } else {
        spend = '$0';
      }

      return spend;
    };

    $scope.getMoneyFormat = function (spend) {
      spend = spend || 0;

      spend = accounting.formatMoney(spend);

      return spend;
    };

    $scope.getCustomerDob = function () {
      if (!$scope.customer) return '';

      const date = _getCustomerDobDate();

      const month = _getCustomerDobMonth();

      const year = _getCustomerDobYear();

      return (!$scope.customer.birthdayDay && !$scope.customer.birthdayMonth && !$scope.customer.birthdayYear) ? 'N/A' : (month + ' ' + date + ' ' + year); //eslint-disable-line
    };

  }

  function _getCustomerDobDate() {
    if (!$scope.customer) return '';

    const dobDate = moment();

    if ($scope.customer.birthdayDay) dobDate.set('date', $scope.customer.birthdayDay);

    return $scope.customer.birthdayDay ? dobDate.format('DD,') : '';
  }

  function _getCustomerDobMonth() {
    if (!$scope.customer) return '';

    const dobDate = moment();

    if ($scope.customer.birthdayMonth) dobDate.set('month', $scope.customer.birthdayMonth - 1);

    return $scope.customer.birthdayMonth ? dobDate.format('MMMM') : '';
  }

  function _getCustomerDobYear() {
    if (!$scope.customer) return '';

    const dobDate = moment();

    if ($scope.customer.birthdayYear) dobDate.set('year', $scope.customer.birthdayYear);

    return $scope.customer.birthdayYear ? dobDate.format('YYYY') : '';
  }

  function _getCustomer() {
    return customerService.readByIdAndOrganizationId($stateParams.id, currentUserOrganization.id)
      .then(customer => {
        $scope.customer = customer;

        _mapCustomerDataToForm();
      })
      .catch(response => {
        const errorMsg = sdkUtils.getErrorFromResponse(response);

        if (errorMsg) loggerService.error(errorMsg);

        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_STAFF_BY_ID);
      });
  }

  function _mapCustomerDataToForm() {
    if (!$scope.customer) return;

    if ($scope.customer.social) {
      if ($scope.customer.social.facebook) $scope.customer.social.facebookUrl = $sce.trustAsResourceUrl($scope.customer.social.facebook);
      if ($scope.customer.social.twitter) $scope.customer.social.twitterUrl = $sce.trustAsResourceUrl($scope.customer.social.twitter);
      if ($scope.customer.social.linkedin) $scope.customer.social.linkedinUrl = $sce.trustAsResourceUrl($scope.customer.social.linkedin);
      if ($scope.customer.social.youtube) $scope.customer.social.youtubeUrl = $sce.trustAsResourceUrl($scope.customer.social.youtube);
      if ($scope.customer.social.instagram) $scope.customer.social.instagramUrl = $sce.trustAsResourceUrl($scope.customer.social.instagram);
      if ($scope.customer.social.vimeo) $scope.customer.social.vimeoUrl = $sce.trustAsResourceUrl($scope.customer.social.vimeo);
    }

    if ($scope.customer.name) {
      $scope.customer.initials = _getCustomerInitials($scope.customer);
    }
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'id',
          'schedule',
          'company',
          'location'
        ].join(',')
      })
      .then((venues) => {
        $scope.venues = venues;
      })
      .catch(response => {
        const errorMsg = sdkUtils.getErrorFromResponse(response);

        if (errorMsg) loggerService.error(errorMsg);

        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_VENUES);
      });
  }

  function _getAdmissionGroups() {
    return admissionGroupService.listByCustomerId($stateParams.id)
      .then(admissionGroups => {
        $scope.admissionGroups = admissionGroups.map(admissionGroup => {
          admissionGroup.date = moment.utc(admissionGroup.date);
          return admissionGroup;
        });

        $scope.admissionGroups = _.sortBy($scope.admissionGroups, admissionGroup => admissionGroup.date * -1);
      })
      .catch(response => {
        const errorMsg = sdkUtils.getErrorFromResponse(response);

        if (errorMsg) loggerService.error(errorMsg);

        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_CUSTOMER_ADMISSION_GROUPS);
      });
  }

  function _processAdmissionGroups() {
    _.each($scope.admissionGroups, admissionGroup => {
      if (admissionGroup.arrivedAt) admissionGroup.arrivedAt = moment(admissionGroup.arrivedAt);

      admissionGroup.venue = _.findWhere($scope.venues, {
        id: admissionGroup.venue
      });

      if (admissionGroup.arrived) $scope.admissionGroup++; //eslint-disable-line

      if (admissionGroup.addedBy) {
        admissionGroup.addedByDetails = _.find($scope.staffMembers, staffMember => staffMember.id === admissionGroup.addedBy);
      }
    });
  }

  function _getCustomerInitials(customer) {
    if (!customer) return '';

    return (customer.name || '')
      .replace(/[^a-zA-Z\s]/g, '')
      .split(/\s/)
      .map(token => {
        return token.length > 0 ? token.substring(0, 1).toUpperCase() : '';
      })
      .join('')
      .substring(0, 4);
  }
}

CustomerProfileCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  '$sce',
  'jsSdk.venue',
  'organizationService',
  'jsSdk.utils',
  'alertService',
  'jsSdk.admissionGroup',
  'dateUtilsService',
  'jsSdk.customer',
  'jsSdk.user',
  'loggerService',
  'ERROR_MESSAGES'
];

export default CustomerProfileCtrl;



// WEBPACK FOOTER //
// ./src/components/customerProfile/customerProfileCtrl.js